import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormsUtils } from '../../shared/forms.utils';
import { Field } from '../interfaces/hubspot-form-data';
// @dynamic
export class CustomInputPhoneValidator {
    static maxLength(field: Field): ValidatorFn {
        const validationData = field.validation.data.split(':');
        return (control: AbstractControl): { [key: string]: any } | null => {
            let _hasMoreThanCountryPrefix = control.value.substring(control.value.indexOf(' ') + 1);
            _hasMoreThanCountryPrefix = _hasMoreThanCountryPrefix.replace(/\s/g, '');
            if (control.value && _hasMoreThanCountryPrefix.length > 0) {
                if (validationData && validationData.length > 0) {
                    const _stringLength = control.value.replace(/\s/g, '').length;
                    const _minLength = parseInt(validationData[0]);
                    const _maxLength = parseInt(validationData[1]);
                    const shouldBeValidated = validationData.length > 2 && 'false' === validationData[2] ? !1 : !0;
                    if (shouldBeValidated && null !== _minLength && null !== _maxLength) {
                        if (_stringLength > _maxLength) {
                            return { length: { valid: false, messageKey: 'phoneInvalidRangeTooLong' } };
                        }
                        if (_stringLength < _minLength) {
                            return { length: { valid: false, messageKey: 'phoneInvalidRangeTooShort' } };
                        }
                    }
                }
            }
        };
    }

    static format(field: Field): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const allowedCharaters = /^\+?(((?:\(x?\d+\))|(?:x?\d+))[\-.]?)+$/i;
            const controlValue = control.value.replace(/\s/g, '');
            if (control.value && !allowedCharaters.test(controlValue)) {
                return { format: { valid: false, messageKey: 'phoneInvalidCharacters' } };
            }
            return null;
        };
    }
}
